import {isEmpty, uniqBy} from 'lodash';
import {FILES_INFO_RECEIVED} from '../store/actionTypes';

export const files = (state = [], action) => {
    switch (action.type) {
        case FILES_INFO_RECEIVED:
            if (!isEmpty(state)) {
                let files = [...state];
                files = files.concat(action.files);
                return uniqBy(files, 'id');
            }
            return action.files;

        default:
            return state;
    }
};
